import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('labelEl', { static: true })
  labelEl: ElementRef<HTMLLabelElement>;

  @Input()
  label: string;

  @Input()
  display: 'inline' | 'block' = 'block';

  @Input()
  theme: 'dark' | 'light' = 'dark';

  @Input()
  uppercase = true;

  @Input()
  isCompact = false;

  private ngUnsubscribe = new Subject();

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    // Note: Fixes issue with editable content (e.g., RichTextEditor) losing focus on click.
    const editableContent = this.labelEl.nativeElement.querySelectorAll('[contenteditable]');
    const hasEditableContent = editableContent.length > 0;

    if (hasEditableContent) {
      fromEvent(this.labelEl.nativeElement, 'click')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((event) => {
          event.preventDefault();
        });
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
